module.exports = __webpack_public_path__ + "img/1949.8deaef18.svg";